import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useTranslation } from 'react-i18next';

export default function AboutPage() {
  const { t } = useTranslation('home');

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="container-main pt-24 pb-16">
        <div className="max-w-3xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6">
            <a href="/" className="hover:text-primary-600 transition-colors">Home</a>
            <i className="ri-arrow-right-s-line text-xs" />
            <span className="text-foreground-600">About</span>
          </nav>

          <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-6">
            About AllChinaBuySpread
          </h1>

          <div className="rounded-lg overflow-hidden mb-8">
            <img
              src="https://readdy.ai/api/search-image?query=Minimal%20modern%20workspace%20with%20laptop%20and%20notebook%20on%20clean%20white%20desk%2C%20warm%20natural%20lighting%20from%20window%2C%20editorial%20photography%20style%2C%20soft%20beige%20and%20cream%20tones%2C%20professional%20aesthetic%2C%20research%20and%20content%20creation%20concept&width=1200&height=500&seq=about-hero-001&orientation=landscape"
              alt="About AllChinaBuySpread"
              className="w-full h-56 md:h-72 object-cover"
            />
          </div>

          <div className="prose prose-sm max-w-none text-foreground-700 leading-relaxed">
            <p className="text-base mb-4">
              AllChinaBuySpread is an independent resource website created to help online shoppers make informed decisions about buying through the AllChinaBuy platform and related shopping agent services.
            </p>

            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">Our Mission</h2>
            <p className="text-base mb-4">
              We believe that buyers deserve access to honest, research-based information before making purchasing decisions. The AllChinaBuy ecosystem can be complex for newcomers, and our goal is to simplify the research process with clear guides, comparisons, and practical tips.
            </p>

            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">Independence & Transparency</h2>
            <p className="text-base mb-4">
              This website is an independent resource and is not affiliated with AllChinaBuy. We do not receive compensation from AllChinaBuy for any content on this site. Our guides and reviews are based on independent research, community feedback, and publicly available information.
            </p>

            <div className="bg-accent-50 rounded-lg p-5 border border-accent-200/50 mb-6">
              <p className="text-sm text-accent-800 font-medium mb-2">Independent Disclosure</p>
              <p className="text-sm text-accent-700 leading-relaxed">
                AllChinaBuySpread is not an official partner or affiliate of AllChinaBuy. We provide independent research and educational content. Product links on this site redirect to AllChinaBuy and kaspreadsheet.com, which are external platforms we do not control.
              </p>
            </div>

            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">What We Offer</h2>
            <ul className="space-y-2 mb-6">
              <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5" /> <strong>Buying guides</strong> — Step-by-step walkthroughs for new users</li>
              <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5" /> <strong>Safety resources</strong> — How to protect yourself from scams and bad sellers</li>
              <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5" /> <strong>Shipping information</strong> — Cost breakdowns by country and shipping method</li>
              <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5" /> <strong>Product research</strong> — Curated category guides for finding specific items</li>
              <li className="flex items-start gap-2"><i className="ri-check-line text-accent-500 mt-0.5" /> <strong>QC tips</strong> — How to read quality control photos and catch defects</li>
            </ul>

            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">Editorial Standards</h2>
            <p className="text-base mb-4">
              Our content is created with the following standards: all information is fact-checked against available sources, we update articles when significant changes occur, we clearly distinguish between verified facts and community-reported experiences, and we never create fake reviews or testimonials.
            </p>

            <p className="text-base mb-6">
              For questions or corrections, please visit our <a href="/contact" className="text-primary-600 hover:underline">Contact</a> page.
            </p>

            <div className="mt-10 bg-primary-50 rounded-lg p-6 md:p-8 text-center border border-primary-200/50">
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Ready to Explore?</h3>
              <p className="text-sm text-foreground-600 mb-4">Browse our guides and resources to get started with smarter shopping.</p>
              <a href="/" className="btn-primary inline-flex">
                Back to Homepage
                <i className="ri-arrow-right-line ml-1" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}